import {Component, input} from '@angular/core';

import {CommonModule} from '@angular/common';

@Component({
  standalone: true,
  selector: 'tmw-check-consult',
  template: `@if (value()) {
    <i class="bi" [ngClass]="value()"></i>
  } @else {
    <i class="bi bi-dash text-muted"></i>
  }`,
  imports: [CommonModule],
})
export class TmwCheckConsultComponent {
  value = input<string | undefined, unknown>(undefined, {
    transform: (val) => {
      if (this.isNullOrUndefined(val)) {
        return undefined;
      } else {
        return val ? 'bi-check text-success' : 'bi-x text-danger';
      }
    },
  });

  isNullOrUndefined(value : any) {
  return value === undefined || value === null;
}
}
